/** Subtract two numbers */
export default function sub(a: number, b: number) {
  return a - b;
}
